import axios from "axios";
const endpoint_name = {
  donation: 'donation',
  projects: 'projects',
  types: 'donation/types',
  banks: 'bankInfo/get-bank-codes'
}
const api = axios.create({
  headers: {
    "Accept": "application/json, */*",
    'Aceess-Control-Allow-Origin': "*",
    'Content-Type': 'application/json',
  },
});

api.request = function (
  endpoint,
  params = {},
  method = "post",
) {
  return new Promise(async (resolve, reject) => {
    if (method === "post") {
      try {
        const res = await api
          .post(endpoint, params);
        if (res.data !== undefined) resolve(res.data);
        else reject(res);
      } catch (error) {
        reject(error);
      }
    }
    else {
      try {
        const res_1 = await api
          .get(endpoint, {
            params,
          });
        if (res_1.data !== undefined && res_1.data) resolve(res_1.data);
        else reject(res_1);
      } catch (error_1) {
        reject(error_1);
      }
    }
  })
}

export const getProjects = async ({urlBase, params}) => {
  return api.request(urlBase + endpoint_name.projects, params, 'get');
};

export const getBanksCode = async ({urlBase, params}) => {
  return api.request(urlBase + endpoint_name.banks, params, 'get');
};

export const getTypesProjects = async ({urlBase, params}) => {
  return api.request(urlBase + endpoint_name.types, params, 'get');
};

export const realizarDonacion = async ({urlBase, params}) => {
  return api.request(urlBase + endpoint_name.donation, params, 'post');
};